import script from "./seller.vue?vue&type=script&setup=true&lang=js"
export * from "./seller.vue?vue&type=script&setup=true&lang=js"

import "./seller.vue?vue&type=style&index=0&id=5256baf9&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5256baf9"]])

export default __exports__